import { timeToMilliseconds } from 'utils/time';

import { DEFAULT_FEATURE_TOGGLES } from './defaults';
import { FeatureToggles } from './types';

let _internalToggles = DEFAULT_FEATURE_TOGGLES;
if (typeof window === 'undefined') {
  const fetchToggles = async () => {
    const { getFeatureToggles } = await import('./getContentfulFeatureToggles');
    _internalToggles = await getFeatureToggles();
  };

  await fetchToggles();

  setInterval(() => {
    void fetchToggles();
  }, timeToMilliseconds(1, 'minutes'));
} else {
  _internalToggles = window.__FEATURE_TOGGLES;
}

export const featureToggles = new Proxy<FeatureToggles>(
  DEFAULT_FEATURE_TOGGLES,
  {
    get(target, prop: keyof FeatureToggles) {
      return _internalToggles[prop] ?? target[prop];
    },
  }
);
